import React from "react";
import { Button } from "../../Button";
import { Container } from "../../Container";
import { useUtilityStyles, UtilityStyle } from "../../hooks/useUtilityStyles";
export const HeaderTitle = ({ title, subtitle, children, reference, status, width = "standard", right, }) => {
    const classes = useUtilityStyles([
        { container: [UtilityStyle.HorizontalPaddingMedium] },
    ]);
    return (React.createElement("div", { className: "page-header" },
        React.createElement(Container, { fluid: width === "full-width", className: width === "full-width" ? classes.container : undefined },
            reference && (React.createElement("div", { className: "pull-right" },
                React.createElement(Button, { label: reference.text, onClick: reference.onClick && reference.onClick, type: "suppressed", id: reference.id }))),
            right && React.createElement("div", { className: "pull-right" }, right),
            (title || subtitle || status) && (React.createElement("div", { className: status ? "page-header--title-status" : undefined },
                title && (React.createElement("h1", null,
                    title,
                    subtitle && typeof subtitle === "string" && (React.createElement(React.Fragment, null,
                        React.createElement("br", null),
                        React.createElement("small", null, subtitle))))),
                subtitle && typeof subtitle !== "string" && (React.createElement("div", { className: "page-header--subtitle", style: { marginTop: 8 } }, subtitle)),
                status && React.createElement("div", { className: "page-header--status" }, status))),
            children)));
};
